export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-1/2 relative h-64 md:h-80 lg:h-auto min-h-[400px] rounded-2xl lg:rounded-r-none overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20streetwear%20outfit%20flatlay%20with%20bomber%20jacket%20sneakers%20and%20accessories%20on%20light%20lavender%20textured%20surface%2C%20editorial%20fashion%20photography%2C%20warm%20golden%20hour%20light%2C%20aspirational%20lifestyle%20composition&width=900&height=1100&seq=cta-v2-image&orientation=portrait"
              alt="AcBuy Spreadsheet latest finds ready to discover"
              title="AcBuy Spreadsheet Ready to Discover"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight drop-shadow-lg">
                Ready to<br />Discover?
              </h2>
            </div>
          </div>

          <div className="w-full lg:w-1/2 bg-white rounded-2xl lg:rounded-l-none p-8 md:p-12 lg:p-14 flex flex-col items-center justify-center text-center">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-6">
              Get The Latest{" "}
              <span className="text-accent-500">AcBuy Finds</span>
            </h2>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10 max-w-md">
              Ready to discover the latest AcBuy finds? Browse our spreadsheet and explore trusted sellers today. Updated weekly with fresh products across all 14 categories.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Shop AcBuy Spreadsheet
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}